import { render } from "./ClientManagerProfileView.vue?vue&type=template&id=40f8cff8"
import script from "./ClientManagerProfileView.vue?vue&type=script&lang=js"
export * from "./ClientManagerProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__